export default __webpack_public_path__ + "static/7 Ways To Choose The Perfect Mattress-7cdb9cc49f17e84d5e2bcc700cc66a37.jpg";